module.exports = __webpack_public_path__ + "img/c07_buildingstartechtownwatch_Normal_ua.d9b35f86.webp";